module.exports = __webpack_public_path__ + "img/mobile-neck-5_176x18.d99ea1dd.png";